import React from 'react';
import { Route, Switch } from 'react-router-dom';
import {
  CreateQuoteWizard,
  EditQuoteWizard,
} from '../quotes/QuoteWizardContainer';
import QuoteListPage from './list/QuoteListPage';
import QuoteViewPage from './view/QuoteViewPage';
import CreateQuoteStep1Container from './step1/CreateQuoteStep1Container';
import CreateQuoteStep2Container from './step2/CreateQuoteStep2Container';
import { CreateQuoteStep3Container } from './step3/CreateQuoteStep3Container';
import ReviewQuoteContainer from './review/ReviewQuoteContainer';

const steps = {
  step1: 'step1',
  step2: 'step2',
  step3: 'step3',
  review: 'review',
  finish: 'finish',
};

export {
  CreateQuoteStep1Container,
  CreateQuoteStep2Container,
  CreateQuoteStep3Container,
  ReviewQuoteContainer,
  steps,
};

const QuoteRoutes = () => (
  <Switch>
    <Route exact path="/quotes/create/:step" component={CreateQuoteWizard} />
    <Route exact path="/quotes/edit/:id/:step" component={EditQuoteWizard} />
    <Route exact path="/quotes" component={QuoteListPage} />
    <Route exact path="/quotes/view/:id" component={QuoteViewPage} />
  </Switch>
);
export { QuoteRoutes };
